"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LandingSection;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactScroll = require("react-scroll");

var _toMoneyFormat = _interopRequireDefault(require("../../utils/toMoneyFormat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 22px;\n\n    @media(max-width: ", "){\n        margin-top: 16px;\n        margin-bottom: 0px;\n    }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    margin-top: 4px;\n    font-size: 32px;\n    line-height: 40px;\n    position: relative;\n    padding-right: 38px;    \n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 22px;\n    color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 2px;\n    right: 0px;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 26px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    margin-right: 40px;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    @media (min-width: ", ") {\n      display: block;\n      margin-right: 0;\n      max-width: 250px;\n    }\n\n    @media (min-width: ", ") {\n      max-width: 200px;\n    }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 18px;\n\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 12px;\n    right: 0px;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 26px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 64px;\n    line-height: 80px;\n    font-weight: normal;\n\n    @media (max-width: ", ") {\n      font-size: 48px;\n      line-height: 64px;\n    }\n\n    @media (max-width: ", ") {\n      font-size: 36px;\n      line-height: 52px;\n    }\n\n    @media (min-width: ", ") {\n      max-width: 230px;\n    }\n\n    @media (min-width: ", ") {\n      max-width: 380px;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    padding-right: 45px;\n    display: inline-block;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 26px;\n    margin-top: 24px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 26px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    flex-grow:1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 40px 56px 64px 56px;\n\n    @media (max-width: ", ") {\n        padding: 32px 12px 56px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LandingSectionStyled = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.backgroundBlue;
}, function (props) {
  return props.theme.breakpointSM;
});

var HeaderStyled = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.colorGray;
});

var SumTitleStyled = _styledComponents.default.div(_templateObject3());

var SumBlockStyled = _styledComponents.default.div(_templateObject4());

var SumStyled = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.theme.breakpointSM;
}, function (props) {
  return props.theme.breackpointXS;
}, function (props) {
  return props.theme.breakpointLG;
}, function (props) {
  return props.theme.breakpointXL;
});

var SumCurrencyStyled = _styledComponents.default.div(_templateObject6());

var SubSumBlockStyled = _styledComponents.default.div(_templateObject7());

var SubSumSectionStyled = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.theme.breakpointLG;
}, function (props) {
  return props.theme.breakpointXL;
});

var SubSumCurrencyStyled = _styledComponents.default.div(_templateObject9());

var SubSumTitleStyled = _styledComponents.default.div(_templateObject10(), function (props) {
  return props.theme.colorGray;
});

var SubSumStyled = _styledComponents.default.div(_templateObject11());

var ButtonWrapperStyled = _styledComponents.default.div(_templateObject12(), function (props) {
  return props.theme.breakpointLG;
});

var BodyStyled = _styledComponents.default.div(_templateObject13());

function LandingSection(props) {
  var results = props.results,
      calculate = props.calculate,
      anchor = props.anchor;
  return /*#__PURE__*/_react.default.createElement(LandingSectionStyled, {
    className: "kpp-calculator__landing"
  }, /*#__PURE__*/_react.default.createElement(BodyStyled, {
    className: "kpp-calculator__body"
  }, /*#__PURE__*/_react.default.createElement(HeaderStyled, {
    className: "kpp-calculator__total"
  }, "\u0418\u0442\u043E\u0433\u043E"), /*#__PURE__*/_react.default.createElement(SumTitleStyled, {
    className: "kpp-calculator__budget"
  }, "\u0411\u044E\u0434\u0436\u0435\u0442 \u043D\u0430 \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0438\u0435 \u041A\u041F\u041F"), /*#__PURE__*/_react.default.createElement(SumBlockStyled, {
    className: "kpp-calculator__sum"
  }, /*#__PURE__*/_react.default.createElement(SumStyled, null, (0, _toMoneyFormat.default)(Math.round(results.kpp) + Math.round(results.motivation.targetContribution))), /*#__PURE__*/_react.default.createElement(SumCurrencyStyled, null, "\u20BD")), /*#__PURE__*/_react.default.createElement(SubSumBlockStyled, {
    className: "kpp-calculator__subsum"
  }, /*#__PURE__*/_react.default.createElement(SubSumSectionStyled, {
    className: "kpp-calculator__subsum-section"
  }, /*#__PURE__*/_react.default.createElement(SubSumTitleStyled, {
    className: "kpp-calculator__subsum-title"
  }, "\u0421\u043E\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0437\u043D\u043E\u0441\u043E\u0432 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432"), /*#__PURE__*/_react.default.createElement(SubSumStyled, {
    className: "kpp-calculator__subsum-result"
  }, (0, _toMoneyFormat.default)(results.kpp), /*#__PURE__*/_react.default.createElement(SubSumCurrencyStyled, null, "\u20BD"))), /*#__PURE__*/_react.default.createElement(SubSumSectionStyled, {
    className: "kpp-calculator__subsum-section"
  }, /*#__PURE__*/_react.default.createElement(SubSumTitleStyled, {
    className: "kpp-calculator__subsum-title"
  }, "\u0426\u0435\u043B\u0435\u0432\u043E\u0439 \u0432\u0437\u043D\u043E\u0441"), /*#__PURE__*/_react.default.createElement(SubSumStyled, {
    className: "kpp-calculator__subsum-result"
  }, (0, _toMoneyFormat.default)(results.motivation.targetContribution), /*#__PURE__*/_react.default.createElement(SubSumCurrencyStyled, null, "\u20BD"))))), /*#__PURE__*/_react.default.createElement(ButtonWrapperStyled, {
    className: "kpp-calculator__button"
  }, /*#__PURE__*/_react.default.createElement(_reactScroll.Link, {
    className: "calculator__button calculator__button_square",
    to: anchor,
    spy: true,
    smooth: true,
    duration: 500 // onClick={(e) => {calculate(e)}}

  }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0440\u0430\u0441\u0447\u0435\u0442")));
}

LandingSection.propTypes = {
  calculate: _propTypes.default.func.isRequired,
  anchor: _propTypes.default.string.isRequired
};